function add_invalid_feedback(input,feedback_container,edge_cases,message){
  var invalid_message = "cannot be blank";
  if(message != null){
    invalid_message = message;
  }

  if(edge_cases == "dropzone"){
    $(".dz-message").addClass("border-danger");
  }else if(edge_cases == "ql-editor"){
    var container = input + " .ql-editor"
    $(container).addClass("border-danger");
  }else if(edge_cases == "country_selector"){
    $(input).next().find('.select2-selection').addClass('border-danger');
  }else if(edge_cases == "new_scholarship_type"){
    $(input).addClass("border-danger");
  }else{
    $(input).addClass("is-invalid");
  }

  if ($(feedback_container).length){
    $(feedback_container).text(invalid_message);
  }else{
    if(edge_cases == "telephone"){
      $(input).parent().parent().parent().append("<div id="+ feedback_container.substring(1, feedback_container.length) +" class='invalid-feedback'>"+ invalid_message +"</div>");
    }else if(edge_cases == "new_scholarship_type"){
        $("#scholarship_type_header").prepend("<div id="+ feedback_container.substring(1, feedback_container.length) +" class='invalid-feedback col-12 mb-2'>"+ invalid_message +"</div>");
    }else if(edge_cases == "edit_scholarship_type"){
        $(input).prepend("<div id="+ feedback_container.substring(1, feedback_container.length) +" class='invalid-feedback mb-2'>"+ invalid_message +"</div>");
    }else if(edge_cases == "dropzone"){
        $(input).append("<div id="+ feedback_container.substring(1, feedback_container.length) +" class='invalid-feedback'>"+ invalid_message +"</div");
    }else if(edge_cases == "ql-editor"){
        $(input).append("<div id="+ feedback_container.substring(1, feedback_container.length) +" class='invalid-feedback'>"+ invalid_message +"</div");
    }else if(edge_cases == "country_selector"){
        $(input).next().append("<div id="+ feedback_container.substring(1, feedback_container.length) +" class='invalid-feedback'>"+ invalid_message +"</div");
    }
    else{
      $(input).parent().append("<div id="+ feedback_container.substring(1, feedback_container.length) +" class='invalid-feedback'>"+ invalid_message +"</div>");
    }
  }
}

export default add_invalid_feedback;